// extracted by mini-css-extract-plugin
export default {"comingsoon":"Waitlist_comingsoon__YaRR8","button":"Waitlist_button__B6LCC","dialogBox":"Waitlist_dialogBox__nzhiV","submitButton":"Waitlist_submitButton__shtaC"};